import {IRingBuffer, useRingBuffer} from "../../../hooks/useRingBuffer";
import {ConsoleFilterUpdate, ConsoleMessage, ConsoleMessageLogType} from "../interfaces";
import {createContext, ReactNode, useContext, useState} from "react";
import {useRPC, useSocket} from "../SocketContext";
import {useWatcher} from "../../../hooks/useWatcher";
import {useEvent} from "../../../hooks/useEvent";
import {rpc_consoleInit} from "../rpc";

const Context = createContext<ConsoleContextData>(null!);

export default function ConsoleContext(props: {children: ReactNode}) {
    const socket = useSocket()

    const messages = useRingBuffer<ConsoleMessage>(1_000)
    const commandHistory = useRingBuffer<string>(10)
    const [messageFilterCount, setMessageFilterCount] = useState(-1)

    useEvent("socketOpen", () => {
        rpc_consoleInit(socket, 1_000).then(init => {
            if (init){
                messages.clear()
                messages.add(...init.history)
                messages.add({type: ConsoleMessageLogType.System, content: "Connected", timestamp: Date.now() / 1000 })
                setMessageFilterCount(init.messageFilterCount)
            }
        })
    })

    useWatcher(socket.isConnected, () => {
        if (!socket.isConnected){
            messages.add({type: ConsoleMessageLogType.System, content: "Connection lost", timestamp: Date.now() / 1000 })
        }
    })

    useRPC(socket, "OnConsoleFiltersUpdated", (update: ConsoleFilterUpdate) => {
        setMessageFilterCount(update.filterCount)
    })

    useRPC(socket, "OnConsoleMessage", (message: ConsoleMessage) => {
        messages.add(message);
    })

    const context: ConsoleContextData = {
        messages,
        commandHistory,
        messageFilterCount
    }

    return (
        <Context.Provider value={context}>
            {props.children}
        </Context.Provider>
    )
}

export const useConsole = () => useContext(Context)

interface ConsoleContextData{
    messages:  IRingBuffer<ConsoleMessage>
    commandHistory: IRingBuffer<string>
    messageFilterCount: number
}